import { useMemo } from 'react'
import { Resume } from '@rio/types'
import { analyzeResume } from '../utils/analyzeResume'
import { Report } from '../types'

export const useAnalyzer = (resume: Resume | null): Report => {
  return useMemo(() => analyzeResume(resume), [resume])
}
